import { render, staticRenderFns } from "./LpAuth3.vue?vue&type=template&id=4ae2b9aa&scoped=true"
import script from "./LpAuth3.vue?vue&type=script&lang=js"
export * from "./LpAuth3.vue?vue&type=script&lang=js"
import style0 from "./LpAuth3.vue?vue&type=style&index=0&id=4ae2b9aa&prod&lang=scss&scoped=true"
import style1 from "./LpAuth3.vue?vue&type=style&index=1&id=4ae2b9aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2b9aa",
  null
  
)

export default component.exports